import React, { useMemo } from "react";
import { useState } from "react";
import { Drawer, LinearProgress, useTheme } from "@mui/material";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import SpeedIcon from "@mui/icons-material/Speed";
import BusinessIcon from "@mui/icons-material/Business";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import ChecklistOutlinedIcon from "@mui/icons-material/ChecklistOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import HardwareOutlinedIcon from "@mui/icons-material/HardwareOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
// import { ReactComponent as SE2050Logo } from "assets/SEI_SE2050_NetZero_logo_color 1.svg";
import SE2050Logo from "../../assets/SEI_SE2050_NetZero_logo_color 1.png";
import { DrawerHeader, drawerWidth } from "Frame";
import { useNavigate } from "react-router-dom";
import { useGetUserQuery } from '../../api/api';

const DrawerMenu = ({ open, handleDrawerClose }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { data: userData, isLoading } = useGetUserQuery();


  const subSuperNavOptions = [
    { label: "Dashboard", iconIndex: 0 },
    { label: "Firms", iconIndex: 1 },
    { label: "Firm Admin", iconIndex: 2 },
    { label: "Firm Users", iconIndex: 3 },
    { label: "Projects", iconIndex: 4 },
    { label: "Privacy Policy", iconIndex: 5 },
    { label: "User Agreement", iconIndex: 6 },
    { label: "Custom Email", iconIndex: 7 },
    { label: "ECOM", iconIndex: 8 },
    { label: "Support", iconIndex: 9 }
  ]

  const firmUserNavOptions = [
    { label: "Dashboard", iconIndex: 0 },
    { label: "Projects", iconIndex: 4 },
    { label: "Support", iconIndex: 9 }
  ]

  const firmAdminNavOptions = [
    { label: "Dashboard", iconIndex: 0 },
    { label: "Firm Admin", iconIndex: 2 },
    { label: "Firm Users", iconIndex: 3 },
    { label: "Projects", iconIndex: 4 },
    { label: "Support", iconIndex: 9 }
  ]

  const superAdminNavOptions = [
    { label: "Dashboard", iconIndex: 0 },
    { label: "Firms", iconIndex: 1 },
    { label: "Sub Super Admin", iconIndex: 2 },
    { label: "Firm Admin", iconIndex: 2 },
    { label: "Firm Users", iconIndex: 3 },
    { label: "Projects", iconIndex: 4 },
    { label: "Privacy Policy", iconIndex: 5 },
    { label: "User Agreement", iconIndex: 6 },
    { label: "Custom Email", iconIndex: 7 },
    { label: "ECOM", iconIndex: 8 },
    { label: "Support", iconIndex: 9 }
  ]

  // const [options, setOptions] = useState(firmUserNavOptions);

  const iconList = [
    <SpeedIcon />,
    <BusinessIcon />,
    <PersonOutlineOutlinedIcon />,
    <GroupsOutlinedIcon />,
    <ChecklistOutlinedIcon />,
    <WorkOutlineOutlinedIcon />,
    <HandshakeOutlinedIcon />,
    <MailOutlineOutlinedIcon />,
    <HardwareOutlinedIcon />,
    <HelpOutlineOutlinedIcon />,
  ];
  const options = useMemo(() => {
    if (userData?.site_role === "Firm Admin") {
      return firmAdminNavOptions;
    } else if (userData?.site_role === "Sub Super Admin") {
      return subSuperNavOptions;
    } else if (userData?.site_role === "Super Admin") {
      return superAdminNavOptions;
    } else {
      return firmUserNavOptions;
    }
  }, [userData?.site_role]);

  return (
    <Drawer
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
        },
      }}
      variant="persistent"
      anchor="left"
      open={open}
    >
      <DrawerHeader>
        <img src={SE2050Logo} alt="SE 2050 Logo" width="70%" />
        <IconButton onClick={handleDrawerClose}>
          {theme.direction === "ltr" ? (
            <ChevronLeftIcon />
          ) : (
            <ChevronRightIcon />
          )}
        </IconButton>
      </DrawerHeader>
      <Divider />
      <List>
        {options.map((item, index) => {
          const handleClick = () => {
            navigate(`/${item.label.toLowerCase().replaceAll(" ", "-")}`);
          }
          return (
            <ListItem key={item.label} disablePadding>
              <ListItemButton
                onClick={handleClick}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  {iconList[item.iconIndex]}
                </ListItemIcon>
                <ListItemText primary={item.label} sx={{ opacity: open ? 1 : 0 }} />
              </ListItemButton>
            </ListItem>
          )
        })}
      </List>
      {isLoading && <LinearProgress />}
    </Drawer >
  );
};

export default DrawerMenu;
